import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default (container = document) => {

  const hero_blog_carousels = {};

  const initCarousel = ($carousel) => {
    const id = $carousel.attr('id');
    let initial_index = 0;

    if (hero_blog_carousels[id]) {
      initial_index = hero_blog_carousels[id].selectedIndex;
      hero_blog_carousels[id].destroy();
      delete hero_blog_carousels[id];
    }
  
    if ($carousel.children().length < 2) {
      // Don't init pointless carousels with 1 or no slides
      $carousel.addClass('AnimateOnLoad--loaded');
      return;
    }
  
    hero_blog_carousels[id] = new Flickity($carousel[0], {
      initial_index,
      // prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      cellSelector: '[data-slide]',
      // cellAlign: 'center',
      // autoPlay: $carousel.data('autoPlay'),
      // pauseAutoPlayOnHover: $carousel.data('pauseAutoPlayOnHover'),
      adaptiveHeight: false,
      contain: true,
      imagesLoaded: true,
      draggable: true,
      on: {
        ready: () => {
          $carousel.addClass('AnimateOnLoad--loaded');
        },
        change: () => {
          let position = hero_blog_carousels[id].selectedIndex + 1;

          if (position < 10) {
            position = `0${position}`;
          }

          $carousel.find('[data-current-position]').html(position);
        },
      },
    });

  };

  $('[data-rte-hero-blog-carousel] [data-carousel]', container).each((i, carousel) => {
    initCarousel($(carousel));
  });
};